var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"flex-grow-0",attrs:{"dense":"","type":"number","value":_vm.value,"label":_vm.label,"placeholder":_vm.placeholder},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }